export default {
  topFilters: [
    {
      name: 'query',
      label: Drupal.t('Search'),
      placeholder: Drupal.t('Search Open Jobs'),
      type: 'autocomplete',
      submitOnResultSelect: true,
    },
    {
      name: 'field_country',
      label: Drupal.t('Country'),
      type: 'select',
      options: [],
    },
    {
      name: 'field_state',
      label: Drupal.t('State/Province'),
      type: 'select',
      options: [],
    },
    {
      name: 'field_city',
      label: Drupal.t('City'),
      type: 'select',
      options: [],
    },
    {
      name: 'field_job_function',
      label: Drupal.t('Career Area'),
      type: 'select',
      options: [],
    },
    {
      name: 'field_target_profile',
      label: Drupal.t('Job Level'),
      type: 'select',
      options: [],
    },
  ],
};
